import {
  get_px8ok5q0jdway2 as get_px,
  plus2opbwe063z9pg as plus,
} from './data.commonHtml.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  divkhq3vjih9fcw as div,
  Dimensions32ju1l7z4mh as Dimension,
  Dimension__toString_impl_o4q1adx82fzjdnbyok as Dimension__toString_impl_o4q1ad,
  Dimension__hashCode_impl_p583vw27ml4nzz2xkra as Dimension__hashCode_impl_p583vw,
} from './data.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.zcz_1 = Edges().ad0(get_px(0));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var EdgesClass;
function Edges() {
  if (EdgesClass === VOID) {
    class $ {
      static bd0(left, top, right, bottom) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.kb2_1 = left;
        $this.lb2_1 = top;
        $this.mb2_1 = right;
        $this.nb2_1 = bottom;
        return $this;
      }
      static cd0(horizontal, vertical) {
        Companion_getInstance();
        return this.bd0(horizontal, vertical, horizontal, vertical);
      }
      static ad0(dimension) {
        Companion_getInstance();
        return this.bd0(dimension, dimension, dimension, dimension);
      }
      dd0(other) {
        return Edges().bd0(plus(this.kb2_1, other.kb2_1), plus(this.lb2_1, other.lb2_1), plus(this.mb2_1, other.mb2_1), plus(this.nb2_1, other.nb2_1));
      }
      plusEdgesNullable(other) {
        return other == null ? this : this.dd0(other);
      }
      ed0(other) {
        return Edges().bd0(div(this.kb2_1, other), div(this.lb2_1, other), div(this.mb2_1, other), div(this.nb2_1, other));
      }
      fd0(left, top, right, bottom) {
        return Edges().bd0(left, top, right, bottom);
      }
      gd0(left, top, right, bottom, $super) {
        left = left === VOID ? this.kb2_1 : left;
        top = top === VOID ? this.lb2_1 : top;
        right = right === VOID ? this.mb2_1 : right;
        bottom = bottom === VOID ? this.nb2_1 : bottom;
        return $super === VOID ? this.fd0(left, top, right, bottom) : $super.fd0.call(this, new (Dimension())(left), new (Dimension())(top), new (Dimension())(right), new (Dimension())(bottom));
      }
      toString() {
        return 'Edges(left=' + Dimension__toString_impl_o4q1ad(this.kb2_1) + ', top=' + Dimension__toString_impl_o4q1ad(this.lb2_1) + ', right=' + Dimension__toString_impl_o4q1ad(this.mb2_1) + ', bottom=' + Dimension__toString_impl_o4q1ad(this.nb2_1) + ')';
      }
      hashCode() {
        var result = Dimension__hashCode_impl_p583vw(this.kb2_1);
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.lb2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.mb2_1) | 0;
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.nb2_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Edges()))
          return false;
        if (!equals(this.kb2_1, other.kb2_1))
          return false;
        if (!equals(this.lb2_1, other.lb2_1))
          return false;
        if (!equals(this.mb2_1, other.mb2_1))
          return false;
        if (!equals(this.nb2_1, other.nb2_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Edges');
    EdgesClass = $;
  }
  return EdgesClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.hd0_1 = new (Rect())(0.0, 0.0, 0.0, 0.0);
      }
      id0(left, top, width, height) {
        return new (Rect())(left, top, left + width, top + height);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var RectClass;
function Rect() {
  if (RectClass === VOID) {
    class $ {
      constructor(left, top, right, bottom) {
        Companion_getInstance_0();
        this.jd0_1 = left;
        this.kd0_1 = top;
        this.ld0_1 = right;
        this.md0_1 = bottom;
      }
      p1() {
        return new (Size())(this.nd0(), this.od0());
      }
      pd0() {
        return (this.jd0_1 + this.ld0_1) / 2;
      }
      qd0() {
        return (this.kd0_1 + this.md0_1) / 2;
      }
      nd0() {
        return this.ld0_1 - this.jd0_1;
      }
      od0() {
        return this.md0_1 - this.kd0_1;
      }
      rd0(left, top, right, bottom) {
        return new (Rect())(left, top, right, bottom);
      }
      toString() {
        return 'Rect(left=' + this.jd0_1 + ', top=' + this.kd0_1 + ', right=' + this.ld0_1 + ', bottom=' + this.md0_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.jd0_1);
        result = imul(result, 31) + getNumberHashCode(this.kd0_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.ld0_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.md0_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Rect()))
          return false;
        if (!equals(this.jd0_1, other.jd0_1))
          return false;
        if (!equals(this.kd0_1, other.kd0_1))
          return false;
        if (!equals(this.ld0_1, other.ld0_1))
          return false;
        if (!equals(this.md0_1, other.md0_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Rect');
    RectClass = $;
  }
  return RectClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.sd0_1 = new (Size())(0.0, 0.0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var SizeClass;
function Size() {
  if (SizeClass === VOID) {
    class $ {
      constructor(width, height) {
        Companion_getInstance_1();
        this.td0_1 = width;
        this.ud0_1 = height;
      }
      b3m(width, height) {
        return new (Size())(width, height);
      }
      vd0(width, height, $super) {
        width = width === VOID ? this.td0_1 : width;
        height = height === VOID ? this.ud0_1 : height;
        return $super === VOID ? this.b3m(width, height) : $super.b3m.call(this, width, height);
      }
      toString() {
        return 'Size(width=' + this.td0_1 + ', height=' + this.ud0_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.td0_1);
        result = imul(result, 31) + getNumberHashCode(this.ud0_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Size()))
          return false;
        if (!equals(this.td0_1, other.td0_1))
          return false;
        if (!equals(this.ud0_1, other.ud0_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Size');
    SizeClass = $;
  }
  return SizeClass;
}
//region block: exports
export {
  Edges as Edges2jf5wl855ambv,
  Size as Size2b01934yxlz5f,
  Companion_getInstance as Companion_getInstance2eccs74uj90kl,
  Companion_getInstance_0 as Companion_getInstance1cv3d7873ycho,
  Companion_getInstance_1 as Companion_getInstanceihdke9ufrn8x,
};
//endregion

//# sourceMappingURL=Rect.mjs.map
